export class InvoicePayment {
    public constructor(init?: Partial<InvoicePayment>) {
      Object.assign(this, init);
    }
    PaymentCode:string;
	LotNumber: string;
	InvoiceNumber: string; 
	ReferenceNumber:  string;
	PaymentAmount: number; 
	TransactionDate: Date; 
	Comments: string; 
	Username: string; 
	IsTrainingData: boolean; 
	FilterDescription: string; 
	IsRSUpdated: boolean; 
	HideOnInvoice: boolean; 
	IsLocked: boolean; 
	PaymentMode: boolean; 
	IsMidnight: boolean;
	PaymentType: string;
	PaymentStatus: number;
	PaymentTransactionType: number;
   }